/*global addiesaas */
import {Vue} from '~/addiesaas'

export const create = (componentName, options = {}) => {
  const vueInit = options.initSync || addiesaas.initSync ||
    (addiesaas.spa && addiesaas.spa.initSync) || initSync
  const el = options.el

  const initOptions = {
    render(h) {
      return h(componentName, options)
    }
  }
  if (el) {
    initOptions.el = el
  }

  const vueApp = vueInit(initOptions)

  if (!el) {
    vueApp.$mount()
  }

  const instance = vueApp.$children[0] || vueApp
  return instance
}

export const getParentSlots = function (vm) {
  vm = vm || this
  if (!vm) {
    return []
  }
  return [
    vm.$parent && vm.$parent.$slots,
    vm.$slots,
    vm.$parent && vm.$parent.$scopedSlots,
    vm.$scopedSlots,
  ]
}
const initSync = (options) => {
  const customVueStrap = {...options || {}}
  const VueApp = new Vue(customVueStrap)
  return VueApp
}

export const setVueData = (vm, path, value) => {
  if (!vm || _.isEmpty(_.trim(path, ''))) {
    return
  }
  const paths = path.split('.')
  if (paths.length === 1) {
    vm[path] = value
    return
  }
  let obj = vm
  do {
    const part = paths.shift()
    if (!_.has(obj, part)) {
      vm.$set(obj, part, {})
    }
    obj = obj[part]

  } while (paths.length > 1)
  const part = paths.shift()
  vm.$set(obj, part, value)
}
